"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validCurrency = exports.validInteger = exports.emptyOrEmail = exports.validEmail = exports.lengthNoMoreThan = exports.notEmpty = exports.getValidationErrors = exports.validate = void 0;
var lodash_1 = require("lodash");
var validator = require("validator");
function validate(data, validators, otherErrors) {
    return __awaiter(this, void 0, void 0, function () {
        var errors;
        return __generator(this, function (_a) {
            errors = __spreadArray(__spreadArray([], getValidationErrors(data, validators)), otherErrors);
            return [2 /*return*/, errors.length > 0 ? Promise.reject({ status: 400, validationErrors: errors }) : Promise.resolve()];
        });
    });
}
exports.validate = validate;
function getValidationErrors(data, validators) {
    var errors = [];
    validators.map(function (entry) {
        if (entry.validator) {
            if (entry.field) {
                checkValidator(entry.field, entry.validator, lodash_1.get(data, entry.field), entry.message, errors);
            }
            else {
                checkValidator("object", entry.validator, data, entry.message, errors);
            }
        }
        else {
            var field = Object.keys(entry)[0];
            checkValidator(field, entry[field], lodash_1.get(data, field), entry.message, errors);
        }
    });
    return errors;
}
exports.getValidationErrors = getValidationErrors;
function checkValidator(field, validator, value, message, errors) {
    if (!validator(value)) {
        errors.push({
            field: field,
            message: message || getDefaultMessage(validator),
        });
    }
}
function getDefaultMessage(validator) {
    if (validator == notEmpty)
        return "Can't be blank";
    if (validator == emptyOrEmail || validator == validEmail)
        return "Invalid email address";
    return "invalid";
}
function notEmpty(str) {
    return str != null && str.toString().trim() != "";
}
exports.notEmpty = notEmpty;
function lengthNoMoreThan(field, name, length) {
    var _a;
    return _a = {},
        _a[field] = function (value) { return !value || value.length <= length; },
        _a.message = name + " cannot be more than " + length + " characters",
        _a;
}
exports.lengthNoMoreThan = lengthNoMoreThan;
function validEmail(value) {
    return value && validator.isEmail(value);
}
exports.validEmail = validEmail;
function emptyOrEmail(value) {
    return !value || validator.isEmail(value);
}
exports.emptyOrEmail = emptyOrEmail;
function validInteger(value) {
    return /^\d+$/.test(value);
}
exports.validInteger = validInteger;
function validCurrency(value) {
    return /^[0-9]+(\.)?([0-9]{1,2})?$/.test(value);
}
exports.validCurrency = validCurrency;
//# sourceMappingURL=validation.js.map